import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import BigCategory from 'modules/budget/components/budget-table/big-category';

const NothingToShow = ({t, colspan, copyLastMonth}) => (
    <tr>
        <td colSpan={colspan} className="text-center">
            <div className="mb-3">{t('BUDGET.TABLE.EMPTY')}</div>
            <button type="button"
                    className="btn btn-primary"
                    onClick={copyLastMonth}
            >{t('BUDGET.TABLE.COPY_LAST_MONTH')}</button>
        </td>
    </tr>
);

@withNamespaces()
@inject('store')
@observer
class BigCategories extends Component {
    constructor(props) {
        super(props);

        this.copyLastMonth = this.copyLastMonth.bind(this);
    }

    copyLastMonth() {
        this.props.store.budget.copyLastMonth();
    }

    render() {
        const { t, categories } = this.props;

        if (categories.length === 0) {
            return <NothingToShow colspan={5} t={t} copyLastMonth={this.copyLastMonth} />
        }

        return categories.map(category => <BigCategory key={category.id} bigCategory={category}/>);
    }
}

BigCategories.propTypes = {
    /** An array of categories from budget store */
    categories: PropTypes.array.isRequired,
};

export default BigCategories;


// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-table/big-categories.js